import { callZigzagFunction } from '../../callZigzagFunction';
import { SaveProduct, SavedProductStatus } from '../../types';
import { zigzagHandler } from '../../handlers';

// 내 상품 추가
export const sp = (saveProduct: SaveProduct) => {
  return new Promise<SavedProductStatus>(resolve => {
    callZigzagFunction('sp')(saveProduct);
    zigzagHandler('onSavedProductStatus', savedProductStatusList => {
      resolve(savedProductStatusList[0]);
    });
  });
};
